import { useTranslations } from "use-intl";
import { ClockCounterClockwiseIcon } from "@phosphor-icons/react";

import { usePreviousCitySearches } from "@/app/lib/hooks/usePreviousSearches";
import { SearchResultList, SearchResultButton } from "./SearchResultList";
import type { City } from "../lib/types/types";

type Props = {
  onClick: (location: City) => void;
};

export function LastSearchedCityList({ onClick }: Props) {
  const t = useTranslations();
  const { previousSearches, removePreviousSearch } = usePreviousCitySearches();

  return (
    <>
      {previousSearches?.length > 0 ? (
        <SearchResultList<City>
          heading={t("hotels.search.lastSearched")}
          data={previousSearches}
          getItemKey={(city) => city.id}
          renderItem={(city) => (
            <SearchResultButton
              icon={ClockCounterClockwiseIcon}
              primaryText={city.name}
              secondaryText={city.countryName}
              onClick={() => onClick(city)}
              onRemove={() => removePreviousSearch(city.id)}
            />
          )}
        />
      ) : null}
    </>
  );
}
